// extracted by mini-css-extract-plugin
export var activeSvg = "styles-module__activeSvg___LhdTM";
export var smallVariant = "styles-module__smallVariant___wUKK6";